import React, { useState, useEffect } from 'react';
import { AiOutlineUser} from "react-icons/ai";
import useStyles from './styles';

import config from '../../enviroment/config.json';
import Header from '../../components/Header';
import Input from '../../components/TextInput';
import Button from '../../components/Button';
import Select from '../../components/Select';
import Loading from '../../components/Loading';
import Modal from '../../components/Modal';
import api from '../../services/api';

function Layout({user, onImgChange, onSave, loading, loadingResetPwd, onChangePassword, changePwdMessage, onChangePwdMessageSubmit}) {
  const c = useStyles();

  const [name, setName] = useState(user.name || "");
  const [sex, setSex] = useState(user.sex || "");
  const [birthDate, setBirthDate] = useState(user.birthDate?.split("T")[0] || "");
  const [company, setCompany] = useState(user.company?.name || "");

  const [country, setCountry] = useState(user.country || "");
  const [state, setState] = useState(user.state || "");
  const [city, setCity] = useState(user.city || "");
  const [selectedChar, setSelectedChar] = useState("01");
  
  const [charOptions, setCharOptions] = useState(false); 
  const availableChars = [
    "01", "02", "03", "04", "05", "06", "07", "08", 
  ]



  const saveData = () => {
    var json = {
      name,
      sex,
      birthDate,
      company: {
        name: company
      },
      country,
      state,
      city
    }

    onSave(json);
  }

  const switchCharOptions = () => {
    setCharOptions(!charOptions);
  }
  
  const changeChar = async () => {
    await onImgChange(selectedChar);
    switchCharOptions();
  }

 
  useEffect(() => {
    setName(user.name || "");
    setSex(user.sex || "");
    setBirthDate(user.birthDate?.split("T")[0]);
    setCompany(user.company?.name || "");
    setCountry(user.country || "");
    setState(user.state || "");
    setCity(user.city || "");
    setSelectedChar(user.char || "01");
  }, [user])

  useEffect(() => {
    document.title = "Settings - Easy Scrum"
  }, [])
  return (
    <>
      <Header></Header>
      <div className={"container " + c.container}>
        <div className={c.settingsHeader}>
          <h2>Settings</h2>

          <Button className={c.saveButton} onClick={saveData} disabled={loading}>{loading ? <Loading color={"white"} size={20}/> : "Save"}</Button>
        </div>

        <h4>Profile Information</h4>
        <section >
          <div className={c.imgBox} onClick={switchCharOptions}>
              <img src={`/chars/${selectedChar}.svg`} alt="User Character Image"></img>
          </div>
          <div className={c.rightInfo}>
            <Input onInput={setName} label={"Name"}  value={name} ></Input>
            <Input label={"Email"} disabled   value={user?.email} ></Input>
            <Select onInput={setSex} value={sex} label={"Sex"} containerStyle={{width: 'auto'}} options={[{label: "Select", value: ""}, {label: "Masculine", value: "Masculine"},{label: "Feminine", value: "Feminine"},{label: "Other", value: "Other"}]}></Select>
            <Input onInput={setBirthDate} label={"Birth Date"} type={"date"}  containerStyle={{width: 'auto'}}  value={birthDate} ></Input>
            <Input onInput={setCompany} label={"Company"}   value={company} ></Input>
            
          </div>
        </section>

        <h4>Credentials Information</h4>
        <section>
          <Input disabled  label={"Login"} value={user?.login}></Input>
          <Input disabled  label={"Password"} value={"Hidden Information"}></Input>
          <div className={c.cngpwdc}>
           <Button className={c.chngpwd} onClick={onChangePassword} disabled={loadingResetPwd}>{loadingResetPwd ? <Loading color={"white"} size={20}/> : "Change Password"}</Button>
          </div>
        </section>


      </div>

      <Modal onCancel={onChangePwdMessageSubmit} visible={changePwdMessage !== null} title={"Reset Password"} submitText={"Ok"} cancelText={false} onSubmit={onChangePwdMessageSubmit}>
          {changePwdMessage}
      </Modal>
      <Modal loading={loading} onCancel={switchCharOptions} visible={charOptions} title={"Choose a Character"} submitText={"Ok"} cancelText={"Cancel"} onSubmit={changeChar}>
          <div className={c.allChars}>
            {availableChars.map(char => {
              return <div onClick={() => setSelectedChar(char)} className={c.characterArea + " " + (selectedChar === char ? "selected" : "")}><img src={`/chars/${char}.svg`} alt="User Character Image"/></div>
            })}
          </div>
      </Modal>
    </>
  );
}

export default Layout;